export const CURRENCY = 'GBP'
export const WEBSITE_URL = process.env.VUE_APP_WEBSITE_URL
